import { ICONS } from "../constants/icons";
import { IMAGES } from "../constants/images";
import useMoveTo from "../constants/navigation";

const MobileHeader = ({
    title,
    isBackBtn,
    handleBack, // 👈 optional custom back handler
    rightElement = null, // 👈 any JSX button or element
}) => {
    const navigate = useMoveTo();

    return (
        <header className="md:hidden grid grid-cols-[auto,1fr,auto] items-center py-4 border-b border-gray-300 dark:border-[#1D1F24] px-6 sticky top-0 bg-white dark:bg-[#1A1A1A] z-40">

            {/* Left */}
            <div className="flex items-center">
                {isBackBtn ? (
                    <button onClick={() => (handleBack ? handleBack() : navigate(-1))} className="p-1.5">
                        <img
                            src={ICONS.arrowBack}
                            className="w-4 h-4 grayscale brightness-0 dark:invert"
                            alt="Back"
                        />
                    </button>
                ) : (
                    <div className="w-8" />
                )}
            </div>

            {/* ✅ Center (Perfectly centered, no absolute) */}
            <div className="flex justify-center">
                {title ? (
                    <h2 className="text-xl font-semibold truncate bg-[#327691] px-3 py-1 rounded-md text-white">
                        {title}
                    </h2>
                ) : (
                    <div className="bg-[#3b819d] px-3 py-1 rounded-md">
                        <img src={IMAGES.dashboardLogo} alt="Zylen" className="h-8" />
                    </div>
                )}
            </div>

            {/* Right */}
            <div className="flex items-center justify-end">
                {rightElement || <div className="w-8" />}
            </div>

        </header>

    );
};

export default MobileHeader;
